import avatar from './img/user.svg'
import avatarDark from './img/user-dark.svg'
import logo from './img/Logo.png'
import clearLogo from './img/Logo.png'
import logos_seduce_home_logo from './img/logos/seduce-home-logo.png'
import logos_seducetoken from './img/logos/seducetoken.png'
import search from './img/search.svg'
import kiss from './img/kiss.svg'
import lkDropdownIcon from './img/lk-dropdown-icon.svg'
import lotImg1 from './img/lot-img-1.jpg'
import exitIcon from './img/exit-icon.svg'
import email from './img/email.png'
import twitch from './img/twitch.svg'
import lotSoldIcon from './img/new-logo.svg'
import externalLink from './img/external-link.svg'
import activityLink from './img/activity-link.svg'
import threepoint from './img/threepoint.svg'
import metamaskLoader from './img/loader-img.svg'
import playIcon from './img/play-icon.svg'
import connectVideo from './img/connect-video.png'
import metamaskLogo from './img/metamask.svg'
import walletConnectLogo from './img/walletconnect.svg'
import shareIcon from './img/share.svg'
import moreIcon from './img/more.svg'
import error404 from './img/404.svg'
import logo_banner from './img/logos/banner.png'
import icons_settings from './img/icons/settings.svg'
import bg_suggestion from './img/bg/suggestion.png'
import icons_discord from './img/icons/discord.svg'
import icons_instagram from './img/icons/instagram.svg'
import icons_github from './img/icons/github.svg'
import icons_medium from './img/icons/medium.svg'
import icons_twitter from './img/icons/twitter.svg'
import icons_telegram from './img/icons/telegram.svg'
import icons_sh_1 from './img/icons/sh_1.png'
import icons_sh_2 from './img/icons/sh_2.png'
import icons_sh_3 from './img/icons/sh_3.png'
import icons_sh_4 from './img/icons/sh_4.png'
import logos_banner from './img/logos/banner.png'
import icons_pankcake from './img/icons/pankcake.png'
import icons_pinksale from './img/icons/pinksale.png'
import logos_roadmap from './img/logos/roadmap.png'
import avatar_jack from './img/avatars/jack.gif'
import avatar_avatar2 from './img/avatars/avatar_2.png'
import avatar_avatar4 from './img/avatars/avatar_4.png'
import avatar_avatar3 from './img/avatars/avatar_3.png'
import icons_badge from './img/icons/Badge.svg'
import sexxy from './img/bg/sexxyy.png'
import rugfreecoin from './img/avatars/rugfreecoins.png'
import techrate from './img/avatars/techrate.png'
import certik from './img/avatars/certik.png'
import avatar_kyle from './img/avatars/kyle.png'
import avatar_ds from './img/avatars/ds.png'
import avatar_chris_PFP from './img/avatars/chris-PFP.png'
import avatar_shelby_main from './img/avatars/shelby_main.png'
import avatar_cherrylovetv from './img/avatars/cherrylovetv.png'
import icons_onlyfans from './img/icons/onlyfans.svg'
import ambassador_first from './img/Ambassadors/first.png'
import ambassador_second from './img/Ambassadors/second.png'
import ambassador_third from './img/Ambassadors/third.png'
import ambassador_forth from './img/Ambassadors/forth.png'
import ambassador_five from './img/Ambassadors/five.png'
import ambassador_six from './img/Ambassadors/six.png'
import ambassador_seven from './img/Ambassadors/seven.png'
import ambassador_eight from './img/Ambassadors/eight.png'
import ambassador_nine from './img/Ambassadors/nine.png'
import ambassador_ten from './img/Ambassadors/ten.png'
import ambassador_eleven from './img/Ambassadors/eleven.png'
import ambassador_twelve from './img/Ambassadors/twelve.png'
import ambassador_thirteen from './img/Ambassadors/thirteen.png'
import ambassador_foureen from './img/Ambassadors/fourteen.png'
import ambassador_fifteen from './img/Ambassadors/fifteen.png'
import ambassador_sixteen from './img/Ambassadors/sixteen.png'
import ambassador_seventeen from './img/Ambassadors/seventeen.png'
import ambassador_eighteen from './img/Ambassadors/eighteen.png'
import ambassador_nineteen from './img/Ambassadors/nineteen.png'
import ambassador_twenty from './img/Ambassadors/twenty.png'
import ambassador_twenty_one from './img/Ambassadors/twenty-one.png'
import ambassador_twenty_two from './img/Ambassadors/twenty-two.png'
import ambassador_twenty_three from './img/Ambassadors/twenty-three.png'
import ambassador_twenty_four from './img/Ambassadors/twenty-four.png'
import ambassador_twenty_five from './img/Ambassadors/twenty-five.png'
import ambassador_twenty_six from './img/Ambassadors/twenty-six.png'
import ambassador_twenty_seven from './img/Ambassadors/twenty-seven.png'
import whitepaper from './img/docs/whitepaper.pdf'
import rice from './img/docs/rice.pdf'

export const img = {
    avatar,
    avatarDark,
    logo,
    search,
    kiss,
    lkDropdownIcon,
    lotImg1,
    exitIcon,
    email,
    twitch,
    lotSoldIcon,
    externalLink,
    activityLink,
    threepoint,
    metamaskLoader,
    playIcon,
    connectVideo,
    metamaskLogo,
    walletConnectLogo,
    shareIcon,
    moreIcon,
    clearLogo,
    error404,
    logo_banner,
    icons_settings,
    bg_suggestion,
    logos_seduce_home_logo,
    icons_discord,
    icons_instagram,
    icons_github,
    icons_medium,
    icons_twitter,
    icons_telegram,
    icons_sh_1,
    icons_sh_2,
    icons_sh_3,
    icons_sh_4,
    logos_seducetoken,
    logos_banner,
    icons_pankcake,
    icons_pinksale,
    logos_roadmap,
    avatar_jack,
    avatar_avatar2,
    avatar_avatar3,
    avatar_avatar4,
    avatar_shelby_main,
    avatar_cherrylovetv,
    icons_badge,
    sexxy,
    rugfreecoin,
    techrate,
    certik,
    avatar_kyle,
    avatar_ds,
    avatar_chris_PFP,
    icons_onlyfans,
    ambassador_first,
    ambassador_second,
    ambassador_third,
    ambassador_forth,
    ambassador_five,
    ambassador_six,
    ambassador_seven,
    ambassador_eight,
    ambassador_nine,
    ambassador_ten,
    ambassador_eleven,
    ambassador_twelve,
    ambassador_thirteen,
    ambassador_foureen,
    ambassador_fifteen,
    ambassador_sixteen,
    ambassador_seventeen,
    ambassador_eighteen,
    ambassador_nineteen,
    ambassador_twenty,
    ambassador_twenty_one,
    ambassador_twenty_two,
    ambassador_twenty_three,
    ambassador_twenty_four,
    ambassador_twenty_five,
    ambassador_twenty_six,
    ambassador_twenty_seven,
    whitepaper,
    rice,
}
